import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Input, Button } from "semantic-ui-react";
import { auth } from "../../firebase";
import { toast } from "react-toastify";
import Layout from "../../hoc/Layout";

const Register = ({ history }) => {
  const [email, setEmail] = useState("");

  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    console.log("user", user);
    if (user && user.token) {
      history.push("/");
    }
  }, [user, history]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const config = {
      url: process.env.REACT_APP_REGISTER_REDIRECT_URL,
      handleCodeInApp: true,
    };
    await auth
      .sendSignInLinkToEmail(email, config)
      .then(() => {
        toast.success(`Please check your inbox to complete registration.`);

        window.localStorage.setItem("registrationEmail", email);
        setEmail("");
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      });
  };

  const registerForm = () => (
    <form onSubmit={handleSubmit} className="mainForm">
      <Input
        type="email"
        className="regInput"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoFocus
        placeholder="email"
      />
      <br />
      <Button type="submit" basic color="purple">
        Register
      </Button>
    </form>
  );

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="ui container ">
          <div className="regForm">
            <h2 className="subTitle">Register</h2>
            <h3 className="subTitle">
              And get notified about upcoming meditations
            </h3>
            {registerForm()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
